/* ============================================================
   KOTART — Navigation JS
   File: assets/kotart-nav.js
   Add to theme.liquid just before </body>:
   <script src="{{ 'kotart-nav.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  /* ---- Mega Menu (Desktop) ---- */
  var megaItems = document.querySelectorAll('.kotart-nav__item--has-mega');
  var megaTimer = null;

  megaItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      clearTimeout(megaTimer);
      megaItems.forEach(function (el) { el.classList.remove('kotart-nav__item--open'); });
      item.classList.add('kotart-nav__item--open');
      var link = item.querySelector('.kotart-nav__link');
      if (link) link.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', function () {
      megaTimer = setTimeout(function () {
        item.classList.remove('kotart-nav__item--open');
        var link = item.querySelector('.kotart-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      }, 120);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.kotart-nav__item--has-mega')) {
      megaItems.forEach(function (el) {
        el.classList.remove('kotart-nav__item--open');
        var link = el.querySelector('.kotart-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ---- Desktop Search ---- */
  var searchToggle = document.getElementById('kotart-search-toggle');
  var searchBar    = document.getElementById('kotart-search-bar');
  var searchClose  = document.getElementById('kotart-search-close');

  function openDesktopSearch() {
    if (!searchBar) return;
    searchBar.classList.add('is-open');
    searchBar.setAttribute('aria-hidden', 'false');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    var input = searchBar.querySelector('input');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function closeDesktopSearch() {
    if (!searchBar) return;
    searchBar.classList.remove('is-open');
    searchBar.setAttribute('aria-hidden', 'true');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      searchBar && searchBar.classList.contains('is-open') ? closeDesktopSearch() : openDesktopSearch();
    });
  }
  if (searchClose) searchClose.addEventListener('click', closeDesktopSearch);

  /* ---- Mobile Drawer ---- */
  var mobToggle  = document.getElementById('kotart-mob-toggle');
  var mobClose   = document.getElementById('kotart-mob-close');
  var mobDrawer  = document.getElementById('kotart-mob-drawer');
  var mobOverlay = document.getElementById('kotart-mob-overlay');

  function openDrawer() {
    if (!mobDrawer) return;
    mobDrawer.classList.add('is-open');
    mobDrawer.setAttribute('aria-hidden', 'false');
    if (mobOverlay) { mobOverlay.classList.add('is-open'); mobOverlay.setAttribute('aria-hidden', 'false'); }
    document.body.classList.add('kotart-drawer-open');
    if (mobToggle) mobToggle.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!mobDrawer) return;
    mobDrawer.classList.remove('is-open');
    mobDrawer.setAttribute('aria-hidden', 'true');
    if (mobOverlay) { mobOverlay.classList.remove('is-open'); mobOverlay.setAttribute('aria-hidden', 'true'); }
    document.body.classList.remove('kotart-drawer-open');
    if (mobToggle) { mobToggle.setAttribute('aria-expanded', 'false'); mobToggle.focus(); }
  }

  if (mobToggle)  mobToggle.addEventListener('click', openDrawer);
  if (mobClose)   mobClose.addEventListener('click', closeDrawer);
  if (mobOverlay) mobOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeDesktopSearch(); }
  });

  /* ---- Mobile Accordion (Level 1 — main categories) ---- */
  function initAccordion(btnsSelector, closeOthers) {
    var btns = document.querySelectorAll(btnsSelector);
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var subId  = btn.getAttribute('aria-controls');
        var subEl  = document.getElementById(subId);
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (closeOthers) {
          btns.forEach(function (b) {
            if (b !== btn) {
              b.setAttribute('aria-expanded', 'false');
              var pm = b.querySelector('.kotart-pm');
              if (pm) pm.textContent = '+';
              var otherId = b.getAttribute('aria-controls');
              var other = document.getElementById(otherId);
              if (other) { other.classList.remove('is-open'); other.setAttribute('aria-hidden', 'true'); }
            }
          });
        }

        var pm = btn.querySelector('.kotart-pm');
        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          if (pm) pm.textContent = '+';
          if (subEl) { subEl.classList.remove('is-open'); subEl.setAttribute('aria-hidden', 'true'); }
        } else {
          btn.setAttribute('aria-expanded', 'true');
          if (pm) pm.textContent = '−';
          if (subEl) { subEl.classList.add('is-open'); subEl.setAttribute('aria-hidden', 'false'); }
        }
      });
    });
  }

  /* Level 1 — top categories (close others when opening) */
  initAccordion('.kotart-mob-nav__btn', true);

  /* Level 2 — sub-groups inside categories (independent) */
  initAccordion('.kotart-mob-grp__btn', false);

  /* ---- Mobile Search Toggle ---- */
  var mobSearchToggle = document.getElementById('kotart-mob-search-toggle');
  var mobSearchBar    = document.getElementById('kotart-mob-search');

  if (mobSearchToggle && mobSearchBar) {
    mobSearchToggle.addEventListener('click', function () {
      var isOpen = mobSearchBar.classList.toggle('is-open');
      mobSearchBar.setAttribute('aria-hidden', String(!isOpen));
      if (isOpen) {
        var input = mobSearchBar.querySelector('input');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    });
  }

  /* ---- Cart Count Update ---- */
  document.addEventListener('cart:updated', function (e) {
    var counts = document.querySelectorAll('.kotart-cart-count');
    counts.forEach(function (el) {
      var count = e.detail && e.detail.itemCount !== undefined ? e.detail.itemCount : '';
      el.textContent = count > 0 ? count : '';
    });
  });

})();